import Axios from "axios";
import { SETTINGS } from "../properties/ApiProps";

export const CountryRepository = {
  getCountries: (name) => {
    return Axios({
      url: SETTINGS.API_URL + "country/filteredByName",
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: {
        nameFilter: name,
      },
    });
  },
};
